import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import CreateNewPass from './CreateNewPass';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading,
    data,
    error,
    message,
    newPasswordSuccess,
  } = state.auth;
  return {
    isLoading,
    data,
    error,
    message,
    newPasswordSuccess,
  };
}

const Styled = withStyles(styles)(CreateNewPass);

export default connect(
  mapStateToProps,
)(Styled);
